export const TypeNameMapBlock = 'mapBlockComponent';
